import { render, staticRenderFns } from "./reservationListItem.vue?vue&type=template&id=c21126aa&scoped=true"
import script from "./reservationListItem.vue?vue&type=script&lang=js"
export * from "./reservationListItem.vue?vue&type=script&lang=js"
import style0 from "./reservationListItem.vue?vue&type=style&index=0&id=c21126aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c21126aa",
  null
  
)

export default component.exports